import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { TrainerFilterStateService } from 'src/app/features/golfer/services/trainer-filter-state.service';

export interface LoginResponse {
  success: boolean;
  message: string;
  data: {
    token: string;
    user_name: string;
    user_status: number;
    userData: any;
    userId: number;
    profile_img: string;
    unread_notification_count: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private filterStateService: TrainerFilterStateService
  ) { }

  login(data: { email: string; password: string; deviceToken: string; remember: boolean }): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.baseUrl}/login`, data);
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Clear trainer filter state on logout to prevent filters from persisting across different user sessions
    this.filterStateService.clearFilterState();
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getUser(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  register(data: any) {
    return this.http.post(`${this.baseUrl}/register`, data);
  }

  forgotPassword(payload: { email: string }) {
    return this.http.post(`${this.baseUrl}/forgot-login`, payload);
  }

  socialLogin(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/social_login`, payload);
  }

  signInWithGoogle(): Observable<any> {
    return this.http.post(`${this.baseUrl}/google-login`, {});
  }

  signInWithApple(): Observable<any> {
    return this.http.post(`${this.baseUrl}/apple-login`, {});
  }
}
